module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-187.e36719d3.svg";